module.exports = __webpack_public_path__ + "assets/headspace_logo-9bc38a7cae9794169e7cc9682642c1b3.webp";